import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import ActionModal from 'components/Modal/ActionModal'
import useActions from 'pages/Ran/Actions/use-actions'
import { trackEvent } from 'analytics'

const Delete = () => {
  const [error, setError] = useState(null)
  const { siteId, roomId } = useParams()
  const apiActions = useActions()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleDelete = async () => {
    const { error: newError } = await apiActions.delete({
      roomId: parseInt(roomId),
    })
    setError(newError)
    if (!newError) {
      trackEvent('private_wifi_deleted', { action_scope: 'item' })
    }
    navigate(`/ran/${siteId}`)
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.remove')}
      description={(
        <Box
          sx={{
            fontSize: 14,
            textAlign: 'center'
          }}
          dangerouslySetInnerHTML={{ __html: t('ran.delete.detail') }}
        />
      )}
      icon={<i className="fa-regular fa-trash" />}
      loading={apiActions.processing}
      onClose={() => navigate('..')}
      onConfirm={handleDelete}
      title={t('ran.delete.title')}
    >
      {Boolean(error) && <Typography color={'error'}>{t('ran.actions.error')}</Typography>}
    </ActionModal>
  )
}

export default Delete
